import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusUnavailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
			fill: "#FFE0A0"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2183_7715)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.0001 14.1667C10.2362 14.1667 10.4341 14.0868 10.5938 13.9271C10.7536 13.7674 10.8334 13.5694 10.8334 13.3333C10.8334 13.0972 10.7536 12.8993 10.5938 12.7396C10.4341 12.5799 10.2362 12.5 10.0001 12.5C9.76397 12.5 9.56605 12.5799 9.40633 12.7396C9.24661 12.8993 9.16675 13.0972 9.16675 13.3333C9.16675 13.5694 9.24661 13.7674 9.40633 13.9271C9.56605 14.0868 9.76397 14.1667 10.0001 14.1667ZM10.0001 10.8333C10.2362 10.8333 10.4341 10.7535 10.5938 10.5937C10.7536 10.434 10.8334 10.2361 10.8334 9.99999V6.66666C10.8334 6.43055 10.7536 6.23263 10.5938 6.07291C10.4341 5.91318 10.2362 5.83332 10.0001 5.83332C9.76397 5.83332 9.56605 5.91318 9.40633 6.07291C9.24661 6.23263 9.16675 6.43055 9.16675 6.66666V9.99999C9.16675 10.2361 9.24661 10.434 9.40633 10.5937C9.56605 10.7535 9.76397 10.8333 10.0001 10.8333ZM10.0001 18.3333C8.8473 18.3333 7.76397 18.1146 6.75008 17.6771C5.73619 17.2396 4.85425 16.6458 4.10425 15.8958C3.35425 15.1458 2.7605 14.2639 2.323 13.25C1.8855 12.2361 1.66675 11.1528 1.66675 9.99999C1.66675 8.84721 1.8855 7.76388 2.323 6.74999C2.7605 5.7361 3.35425 4.85416 4.10425 4.10416C4.85425 3.35416 5.73619 2.76041 6.75008 2.32291C7.76397 1.88541 8.8473 1.66666 10.0001 1.66666C11.1529 1.66666 12.2362 1.88541 13.2501 2.32291C14.264 2.76041 15.1459 3.35416 15.8959 4.10416C16.6459 4.85416 17.2397 5.7361 17.6772 6.74999C18.1147 7.76388 18.3334 8.84721 18.3334 9.99999C18.3334 11.1528 18.1147 12.2361 17.6772 13.25C17.2397 14.2639 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.264 17.2396 13.2501 17.6771C12.2362 18.1146 11.1529 18.3333 10.0001 18.3333Z",
				fill: "#775D1F"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2183_7715",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
export default SvgStatusUnavailable;
